import { Component, OnInit, ViewChild, ElementRef, NgZone } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import { CommonHttpService } from '../commonHttp.service';
import { LoaderService } from '../../_shared/services/loader.service';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/first';
import { } from 'jquery';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.css']
})
export class TermsComponent implements OnInit {

constructor(private service: CommonHttpService) {
   
}
ngOnInit() {
}
}



// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/components/referral-terms/terms.component.ts